<template>
<div class="chapter">
<div class="inner_page">
<div class="cover">
<span epub:type="pagebreak" id="page_v" title="v"><img alt="title" src="images/title.jpg"/>
</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?c0f9c61e